import { Flex } from '@chakra-ui/react';
import ContractDetailView from '@features/explore/ContractDetailView';
import { Contract } from 'helpers/fakeData';

interface Props {
  contract: Contract;
}

const ContractInfo = ({ contract }: Props) => {
  return (
    <Flex bg="surface.background" borderRadius="lg">
      <ContractDetailView contract={contract} hideSupplyButton />
    </Flex>
  );
};

export default ContractInfo;
